












import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import IFilterModel from "@models/IFilterModel";
import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"

@Component
export default class TableFilterComponent extends Vue {
    @Prop({type: Object, required: true}) filter: IFilterModel;
    @Prop({default: false}) noClearBtn: boolean;
    clear() {
        this.filter.resetToDefault();
        this.search();
    }
    search() {
        const request = this.filter.toFilterRequest();
        this.$emit('search', request);
    }
}
